import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "chart-header" }
const _hoisted_2 = { class: "chart-title" }
const _hoisted_3 = { class: "chart-subtitle" }
const _hoisted_4 = {
  ref: "chartContainer",
  class: "chart-svg-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "candlestick-chart-container mx-auto",
    style: _normalizeStyle(_ctx.containerStyle)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.symbol), 1),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.subtitle), 1)
    ]),
    _createElementVNode("div", _hoisted_4, null, 512)
  ], 4))
}